module.exports = tribe.common.utils.globals;